import { Injectable } from '@angular/core';
import { Observable, map, of } from 'rxjs';
import { DataStorageService } from '../storage';
import { BaseService } from '@shared/core';
import { IResponse, IUserModel } from '../../models';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  get userInfo(): IUserModel | undefined {
    return this.storageService.getUserData();
  }

  get userInfo$(): Observable<IUserModel | undefined> {
    return this.storageService.onUserDataChanged<IUserModel>();
  }

  constructor(private storageService: DataStorageService, private baseService: BaseService) {}

  getCurrentUser(): Observable<IUserModel> {
    if (this.userInfo) {
      return of(this.userInfo);
    }
    return this.baseService.get<IResponse<IUserModel>>('auth/current-user').pipe(
      map(response => {
        this.storageService.setUserData(response.value);
        return response.value;
      }),
    );
  }

  clearUserUnfo(): void {
    this.storageService.clearUserData();
  }

  logoutFromUser(): void {
    this.storageService.logout();
  }
}
